module.exports = __webpack_public_path__ + "img/1DPlus.3ed7bc59.jpg";